export { default } from './Izenda.FilterWrap';


// WEBPACK FOOTER //
// ./ui/share/components/controls/Filter/index.jsx